import { Tree } from './Tree'
import { Address } from './Address'
import { Demand } from './Demand'
import { IHandlerOperation } from './HandlerOperation'
import { UserCreate } from './User'

export class Appraisal {
	public _id: string
	public scheduling_date: Date
	public identification: number
	public evaluator: UserCreate
	public status: string
	public address: Address
	public demands: Array<Demand>
	public evaluationResult: EvaluationResult
	public report?: Report
	public tree?: Tree
	public handlerOperations: Array<HandlerOperation>
	}

class HandlerOperation {
	public managementConfiguration: {
		status: string
	}
	public handlerOperation: IHandlerOperation
}

export class Report {
	public responsible: string
	public date: string
	public file: Array<any>
	public risk: string
}

export class EvaluationResult {
	public degreeRisk: { value: number; title: string }
	public conclusionDate: Date
}

export class LocationAndSituation {
	public address: string
	public number?: string
	public city?: string
	public state?: string
	public cep?: string
	public geographicCoordinates?: string
	public locationCategory: string
	public deadTree: string
	public comments: string
	public images?: Array<any>
}
export class Evaluation {
	public evaluationTime: string
	public responsible: string
	public date: Date
	public treeNumber: string
}

export class ReportNew {
	public tree: any
	public evaluation: Evaluation
	public locationAndSituation: LocationAndSituation
}

export class AppraisalEvaluationArboreal {
	public idMongo: string
	public date: string
	public process: string
	public demandStatus: 'WITHOUT_DEMAND' | 'WITH_DEMAND' | 'ADDED_DEMAND'
	public requester: {
				name: string;
				cpf: string;
		telephone: string;
		email: string;
		cnpj: string;
		socialName: string;
		notEditable: boolean;
	}
	public responsible: {
		idMongo: string;
				name: string;
				crea: string;
		email: string;
	}
	public reportEditionDate: string
	public responsibleForEdition: string
	public address: {
				street: string;
				coordenates: string;
				locationCategory: string;
				comments: string;
		}
	public tree: {
				idMongo: string;
				identification: number;
				identifier: string;
				specie: string,
				popularName: string,
				family: string,
				source: string,
				specialCategory: string,
				specieId: string,
				totalHeight: string,
				dapCap: string,
				dapCapType: string,
				stemHeight: string,
				woodVolume: string,
				cupProjection: string,
				specialValue: string,
				treeFormat: {
						url: string,
						status: string
				},
				mediaTree: string;
		status: string;
		notFound: boolean;
		notFoundReason: 'ADDRESS_INVALID' | 'TREE_REMOVED' | 'RESIDENT_NOT_HOME'
		textJustify: string;
		treeState: 'ALIVE' | 'DEAD';
		}
	public considerations: string
	public appraisalDone: boolean
	public assign: boolean
	public responsibleForSign: {
		name: string,
		crea: string
	}
		public evaluationResult: {
		degreeOfRisk: {
			value: number,
			title: string,
			edited: boolean
		},
		nextEvaluation: {
			month: string,
			title: string,
			edited: boolean
		},
		residualRisk: {
			value: number,
			title: string,
			edited: boolean
		},
		depthEvaluation: {
			requested: string,
			edited: boolean
		},
		fallProbability: {
			value: number,
			title: string,
			edited: boolean
		},
		impactProbability: {
			value: number,
			title: string,
			edited: boolean
		},
		fallConsequence: {
			value: number,
			title: string,
			edited: boolean
		}
	}
	public handleOperations: Array<HandlerOperations>
	public answersWithImagens?: Array<{
		url: string,
		question: string,
		answer: Array<string>,
		other: {
			question: string,
			answer: string
		}
	}>
	public answersNoImagens?: Array<{
		url: string,
		question: string,
		answer: Array<string>,
		other: {
			question: string,
			answer: string
		}
	}>
	public riskAssessment?: {
		av1: {
			title: string,
			status: 'released' | 'no-released' | 'required';
		},
		av2: {
			title: string,
			status: 'released' | 'no-released' | 'required';
		},
		av3: {
			title: string,
			status: 'released' | 'no-released' | 'required';
		}
	}
	public qrCodeImage: string
	public oldReport: string
	public hasLegalfundamentation: boolean
	}

export class HandlerOperations {
	public idMongo: string
	public operation: string
	public status?: string
	public legalFundamentation?: string
	public sections?: Array<Section>
}

export class Section {
	public id: number
	public name: string
	public description: string
}

export class AllPinsFromScheduleAppraisal {
	public trees: Array<ScheduleTree> = []
	public appraisals: Array<ScheduleAppraisal> = []
}

export class ScheduleTree {
	public idMongo: string
	public identification: number
	public lat: number
	public lng: number
}

export class ScheduleTreeDetails {
	public idMongo: string
	public identification: number
	public createDate: string
	public media: Array<string>
	public mediaSelected: string
	public specie: string
	public family: string
	public dap: string
	public height: string
}

export class ScheduleAppraisal {
	public idMongo: string
	public lat: number
	public lng: number
}

export class ScheduleAppraisalDetails {
	public idMongo: string
	public media: Array<string>
	public street: string
	public lat: number
	public lng: number
	public evaluator: {
		idMongo: string;
		name: string;
	}
	public schedulingDate: string
}

export class AppraisalCommunication {
	public idMongo: string
	public demandId: number
	public identification: string
	public treeId: number
	public cnpjRequester: string
	public socialNameRequester: string
	public requester: string
	public cpfRequester: string
	public address: string
	public coordinates: string
	public createDate: string
	public process: string
	public protocol: number
	public treeMedia: string
	public handlerOperations: Array<string>
	public finalConsiderations: string
	public assign: boolean
	public companySocialName: string
	public companyComments: string
	public emailCompany: string
	public telephoneCompany: string
	public companyAddress: string
	public imgLinkLogoCompany: string
	public imgLinkLogoPublicBody: string
	public qrCode: string
	public done: boolean
	public specie: string
	public popularName: string
	public notFoundMedia: Array<string>
	public isNotification: boolean
	public textJustify: string
}
